<template>
  <div class="tab-item-content">
    <div class="search-layout">
      <template v-if="!expanded">
        <div class="item-wrap long">
          <el-input size="small" placeholder="业务人员ID/业务人员手机号/真实姓名/订单号" v-model.trim="formRef.nameLike" clearable />
        </div>
      </template>
      <template v-else>
        <div class="item-wrap">
          <el-input size="small" placeholder="业务人员ID" v-model.trim="formRef.salesJobNumber" clearable />
        </div>
        <div class="item-wrap">
          <el-input size="small" placeholder="业务员手机号" v-model.trim="formRef.contactInformation" clearable />
        </div>
        <div class="item-wrap">
          <el-input size="small" placeholder="真实姓名" v-model.trim="formRef.truthName" clearable />
        </div>
        <div class="item-wrap">
          <el-input size="small" placeholder="订单号" clearable v-model.trim="formRef.orderCode" />
        </div>
        <div class="item-wrap">
          <el-select v-model="formRef.transactionType" placeholder="收入类型" size="small" clearable>
            <el-option v-for="item in transactionTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item-wrap">
          <el-select v-model="formRef.incomeStatus" placeholder="收入状态" size="small" clearable>
            <el-option v-for="item in incomeStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item-wrap long">
          <el-date-picker size="small" v-model="formRef.detailCreateTime" clearable type="datetimerange"
            range-separator="至" value-format="yyyy-MM-dd" start-placeholder="明细创建时间-开始" end-placeholder="明细创建时间-结束">
          </el-date-picker>
        </div>
      </template>
      <div class="item-wrap op">
        <el-button size="small" @click="resetForm">重置</el-button>
        <el-button type="primary" @click="getcheckList(1)" size="small"> 搜索 </el-button>
        <el-button type="text" size="small" @click="handleExpand()">
          {{ expanded ? "收起" : "展开"
          }}<i :class="{
    'el-icon-arrow-up': expanded,
    'el-icon-arrow-down': !expanded,
    'el-icon--right': true,
  }"></i>
        </el-button>
      </div>
    </div>
    <div class="table-wrap">
      <MyTable :table-data="tableData" @sort-change="sortChange" :index="index" :selection="selection" :page="page"
        :operation="false" :table-option.sync="tableOption" @page-change="getcheckList"
        @handleSelectionChange="currentChange">
        <template slot="amount" slot-scope="scope">
          {{ toDecimal(scope.row.amount) }}
        </template>
        <template slot="orderCode" slot-scope="scope">
          {{ scope.row.orderCode && scope.row.transactionType != '开户奖励' ? scope.row.orderCode : '' }}
        </template>

      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import { queryIncomeDetail } from "@/api/externalSalesRule/index.js";
import { toDecimal2 } from "@/utils/index.js"
const incomeStatusOptions = [{
  value: 0,
  label: '待结算'
}, {
  value: 1,
  label: '已结算'
}, {
  value: 2,
  label: '已失效'
}]

const transactionTypeOptions = [{
  value: 'BASIC_SERVICE_CHARGE',
  label: '基础服务费'
}, {
  value: 'PROMOTION_SERVICE_FEE',
  label: '推广服务费'
}, {
  value: 'FIRST_ORDER_BONUS',
  label: '首单奖励'
}, {
  value: 'ACCOUNT_OPENING_BONUS',
  label: '开户奖励'
}]

export default {
  components: {
    MyTable,
  },
  props: {
    salesJobNumber: {
      default: "",
    },
  },
  data () {
    return {
      expanded: false,
      transactionTypeOptions: transactionTypeOptions,
      incomeStatusOptions: incomeStatusOptions,
      formRef: {
        detailCreateTime: [],
        transactionType: '',
        incomeStatus: '',
        nameLike: "", //业务人员ID/业务人员手机号/真实姓名/身份证号/银行卡号
        salesJobNumber: "", //业务员工号/就是页面上的业务员id
        contactInformation: "", //业务员手机号
        truthName: "", //真实姓名
      },

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        {
          label: "明细创建时间",
          prop: "detailCreateTime",
          sortable: "custom",
          minWidth: 120,
        },
        { label: "业务人员ID", prop: "salesJobNumber", minWidth: 120 },
        { label: "业务人员手机号", prop: "contactInformation", minWidth: 120 },
        { label: "真实姓名", prop: "truthName", minWidth: 120 },
        {
          label: "订单号/客户ID",
          prop: "orderCode",
          minWidth: 120,
          solt: true,
        },
        {
          label: "收入类型",
          prop: "transactionType",
          minWidth: 120
        },
        { label: "金额", prop: "amount", sortable: "custom", minWidth: 120 },
        {
          label: "状态",
          prop: "incomeStatus",
          minWidth: 120
        },
      ],
      page: {
        total: 1,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },
      sortTag: null,
    };
  },
  filters: {

  },
  created () {
    this.formRef.nameLike = this.salesJobNumber || '';
  },
  mounted () {
    this.getcheckList();
  },
  methods: {
    toDecimal (x) {
      return toDecimal2(x)
    },
    resetForm () {
      this.formRef = {};
      this.formRef.detailCreateTime = [];
      this.getcheckList()
    },
    handleExpand () {
      this.expanded = !this.expanded;
    },
    currentChange (val) {
      console.log("current", val);
    },
    sortChange (val) {
      console.log(val, 'val')
      if (val.prop == "detailCreateTime") {
        if (val.order == "ascending") {
          this.sortTag = 1;
        }
        if (val.order == "descending") {
          this.sortTag = 2;
        }
      }

      if (val.prop == "amount") {
        if (val.order == "ascending") {
          this.sortTag = 3;
        }
        if (val.order == "descending") {
          this.sortTag = 4;
        }
      }

      if (val.order == null) {
        this.sortTag = ""
      }
      this.page.current = 1;
      this.getcheckList();
    },
    getcheckList (currents) {
      if (currents) this.page.current = currents
      const { current, size } = this.page;
      let params = {
        current,
        size,
        sortTag: this.sortTag,
        ...this.formRef,
      };
      console.log(params)
      if (this.formRef.detailCreateTime) {
        params.createStartTime = this.formRef.detailCreateTime[0]
        params.createEndTime = this.formRef.detailCreateTime[1]
      }

      delete params.detailCreateTime;
      queryIncomeDetail(params).then((res) => {
        if (res) {
          if (!res.records) {
            this.tableData = [];
            this.page.total = 0;
            this.tabsData.forEach((item) => {
              // item.num = 0
              item.numhide = true;
            });
            return;
          }
          const { records, total } = res;
          this.page.total = total;
          this.tableData = records;
          console.log(this.tableData, '---this.tableData')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";

.statics {
  display: flex;
  flex-direction: row;

  .item {
    width: 120px;
    height: 80px;
    background: #f5222d;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:not(:first-child) {
      margin-left: 8px;
    }

    .tip {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
    }

    .value {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
      margin-top: 4px;
      max-width: 96%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
